module.exports = __webpack_public_path__ + "static/wind-blowing-da529781165e3aea39d5f97088814d81.wav";